import { render } from "./StakeModal.vue?vue&type=template&id=3ad34bca&scoped=true&ts=true"
import script from "./StakeModal.vue?vue&type=script&lang=ts"
export * from "./StakeModal.vue?vue&type=script&lang=ts"

import "./StakeModal.vue?vue&type=style&index=0&id=3ad34bca&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad34bca"]])

export default __exports__